module.exports = __webpack_public_path__ + "img/lion.0147817f.svg";